import React, { useEffect, useState } from 'react';
import NumberFormat from 'react-number-format';
import { useCurrentMeasurment } from '../helper';

type CustomProps = {
  onChange: (event: { target: { name: string; value: string } }) => void;
  inputRef: unknown;
  name: string;
};

// @ts-ignore
export const NumberFormatCustom = React.forwardRef<NumberFormat, CustomProps>(function NumberFormatCustom(props, ref) {
  const { onChange, inputRef, ...other } = props;
  const current = useCurrentMeasurment();
  const [sufix, setSufix] = useState(' cm');

  useEffect(() => {
    current?.value && setSufix(' ' + current.value.toLowerCase());
  }, [current?.value]);

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      isNumericString
      suffix={sufix}
    />
  );
});
